module.exports = __webpack_public_path__ + "12.0832508c.jpg";